module.exports = __webpack_public_path__ + "img/card-2b-report.983a77c5.svg";